import React from 'react';
import {
  useSelector,
} from 'react-redux';
import {
  FieldArrayRenderProps,
  useField,
} from 'formik';
import { StoreShape } from 'hellospa/redux/types';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import * as types from 'hellospa/page/prep-and-send/data/types';
import { useIntl } from 'react-intl';

import styles from '../index.scss';
import messages from '../intl';
import PlusIcon from '../icons/plus';

const AddRecipientBtn = ({ helper }: { helper: FieldArrayRenderProps }) => {
  const intl = useIntl();
  const workflow = useSelector(selectors.getWorkflow);
  const addRecipientAction = useSelector(selectors.getRecipientGenerator);
  const [field] = useField<types.Recipient[]>('recipients');
  const [qesField] = useField<boolean>('qes');
  let disabled = false;

  if (qesField.value) {
    disabled = true;
  }

  const allowAdd = useSelector((state: StoreShape) => (
    selectors.allowRecipientAdd(state, field.value)
  ));

  if (!allowAdd || !addRecipientAction) {
    return null;
  }

  let msg = intl.formatMessage(messages.addRecipientRecipientButton);
  if (workflow.tags.includes(types.WorkflowTags.SignatureRequestDocument)) {
    msg = intl.formatMessage(messages.addRecipientSignerButton);
  }
  if (workflow.tags.includes(types.WorkflowTags.CreateTemplate)) {
    msg = intl.formatMessage(messages.addRecipientRoleButton);
  }

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => helper.push(addRecipientAction())}
      className={styles.addSigner}
      data-qa-ref="recipients.buttons.add_row"
    >
      <PlusIcon className={styles.plusIcon} />
      {msg}
    </button>
  );
};

export default AddRecipientBtn;
